export default __webpack_public_path__ + "static/media/flip.d16d402f.svg";